// When the server defers the row count (no meta.total in the list response), fetch it
// after the rows are shown and patch the pagination total. Service needs getCount().
export const loadDeferredTotal = (response, service, params, filter, classicFilters, dispatch, setPagination) => {
    if (!response?.meta || response.meta.total !== undefined) {
        return;
    }

    service.getCount(params, filter, classicFilters)
        .then((total) => {
            // ignore a bad/missing total so the estimate (and Next button) stays
            if (!Number.isFinite(Number(total))) return;
            const perPage = Number(params.per_page) || 10;
            dispatch(setPagination({ total, last_page: Math.max(1, Math.ceil(total / perPage)) }));
        })
        .catch(() => { });
};
